// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import assetInventoryCheckEntity from './entities/asset-inventory-check.json';
import assetInventoryCheckMenu from '../pages/asset-inventory-check/menu.json';
import assetInventoryCheckFullForm from '../pages/asset-inventory-check/forms/full.json';
import assetInventoryCheckContextForm from '../pages/asset-inventory-check/forms/context.json';
import assetInventoryCheckMiniForm from '../pages/asset-inventory-check/forms/mini.json';
import assetInventoryCheckLookupForm from '../pages/asset-inventory-check/forms/lookup.json';
import assetInventoryCheckTableView from '../pages/asset-inventory-check/views/table.json';
import assetInventoryCheckCardsView from '../pages/asset-inventory-check/views/cards.json';
import assetInventoryCheckCalendarView from '../pages/asset-inventory-check/views/calendar.json';
import assetInventoryCheckDashboardView from '../pages/asset-inventory-check/views/dashboard.json';

/** Тип запису «Інвентаризація» зі сторінками пакета: меню, форми та подання з pages/asset-inventory-check/. */
export const assetInventoryCheckDefinition: IRecordTypeDefinition = {
  ...assetInventoryCheckEntity,
  views: assembleViewSet({
      table: assetInventoryCheckTableView,
      cards: assetInventoryCheckCardsView,
      calendar: assetInventoryCheckCalendarView,
      dashboard: assetInventoryCheckDashboardView,
  }),
  form: assetInventoryCheckFullForm,
  forms: { full: assetInventoryCheckFullForm, context: assetInventoryCheckContextForm, mini: assetInventoryCheckMiniForm, lookup: assetInventoryCheckLookupForm },
  menu: assetInventoryCheckMenu,
} as IRecordTypeDefinition;
